import axios from "axios";
import { attachUnauthorizedResponseInterceptor } from "../auth/unauthorizedSession";
import { AUTH_KEYS } from "../auth/authKeys";

function getSessionToken(): string {
  return localStorage.getItem(AUTH_KEYS.SESSION_TOKEN) || "";
}

function getApiBaseUrl(): string {
    const rawBaseUrl =
        import.meta.env.MODE === "production"
            ? import.meta.env.VITE_BASE_URL_PROD
            : import.meta.env.VITE_BASE_URL_DEV;

    return String(rawBaseUrl || "").trim().replace(/\/+$/, "");
}

/**
 * Configuração para as APIs que necessitam de autenticação
 * @param Authorization - Token de autorização
 * @param AuthorizationRA - Token de autorização do RA
 * @param AuthorizationForce - Token de autorização do Force
 * @param instance - Instância da API
 * @returns Instância da API configurada
 */

export function SetupNotAuth() {
    const baseURL = getApiBaseUrl();

    const api = axios.create({
        baseURL,
    });
    /** Evita preflight em GET simples (Accept padrão do Axios dispara OPTIONS em alguns proxies). */
    api.defaults.headers.common.Accept = "*/*";

    attachUnauthorizedResponseInterceptor(api, { notifyOn401: false });

    return api;
}

export function SetupFlowRC(
    AuthorizationRA: string = "",
    Authorization: string = ""
) {
    const baseURL = getApiBaseUrl();

    const api = axios.create({
        baseURL,
        headers: {
            Authorization,
            AuthorizationRA,
            "X-Session-Token": getSessionToken(),
        },
    });

    attachUnauthorizedResponseInterceptor(api);

    return api;
}

export function SetupAuth(Authorization?: string) {
    const baseURL = getApiBaseUrl();

    const api = axios.create({
        baseURL,
        headers: {
            Authorization: Authorization || "",
            "X-Session-Token": getSessionToken(),
        },
    });

    attachUnauthorizedResponseInterceptor(api);

    return api;
}